import React from "react";
import { IconProps } from "./Icon.types";

const Icon: React.FC<IconProps> = ({
  name,
  alt = "",
  className = "",
  theme = "dark",
}) => {
  const isDark = theme === "dark";

  // Light tema için tema ikonlarını filtreleyerek koyu renge çevir
  const iconStyle: React.CSSProperties = {
    width: "18px",
    height: "18px",
    filter: "none", // Tema ikonları için filtreleme kaldırıldı
  };

  return (
    <img
      src={`/icons/${name}.svg`}
      alt={alt}
      className={className}
      style={iconStyle}
    />
  );
};

export default Icon;
